(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-blog"] && !Shopify.designMode) return;
  try {
      
document.querySelectorAll('[id^="shopify-section-"]').forEach((card, index) => {
   console.log = function(){};
   if(card.classList.contains('featured-blog')) {     
    const topHeading = card.querySelectorAll('.for-arrow-alignment');        
    const cardHeight = parseInt(topHeading[0].clientHeight);
    const topValue = cardHeight / 2 + 5;
    const cardTopCSS = "calc(50% - "+topValue+'px)';     
    const swiperContainer = card.querySelector('.swiper');    
     if(!swiperContainer) return;
    const swiperPrevElement = swiperContainer.querySelector('.swiper-button-prev');    
    const swiperNextElement = swiperContainer.querySelector('.swiper-button-next');     
    if(!swiperPrevElement || !swiperNextElement) return
    swiperPrevElement.setAttribute('style', 'top:'+cardTopCSS);    
    swiperNextElement.setAttribute('style', 'top:'+cardTopCSS);
  }        
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() { super(); }
    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }
    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }
    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }
    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }
    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }
    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
  }
  customElements.define('sticky-header', StickyHeader);

  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }
    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }
    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
      this.hidePanel();
      this.elements.button.focus();
    }
    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }
    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }
    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }
  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    

class ApronzeProductRecommendations extends HTMLElement {
  constructor() {
    super();
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => {
          if (!response.ok) throw new Error('Unable to load product recommendations.');
          return response.text();
        })
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
            this.dispatchEvent(new CustomEvent('apronze:recommendations-loaded', { bubbles: true }));
          }
        })
        .catch(error => {
          console.error('APRONZE product recommendations error:', error);
        });
    };

    const observer = new IntersectionObserver(
      handleIntersection.bind(this),
      { rootMargin: '0px 0px 250px 0px' }
    );
    observer.observe(this);
  }
}

if (!customElements.get('product-recommendations')) {
  customElements.define('product-recommendations', ApronzeProductRecommendations);
}

/* WISHLIST */

(function () {
  'use strict';
  const WISHLIST_KEY = 'custom_wishlist';

  function getWishlist() {
    try {
      const raw = JSON.parse(localStorage.getItem(WISHLIST_KEY)) || [];
      return raw.map(function (item) {
        if (typeof item === 'object' && item !== null) return item;
        return { id: String(item), handle: null };
      });
    } catch (e) { return []; }
  }

  function saveWishlist(list) {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
    window.dispatchEvent(new Event('wishlistUpdated'));
  }

  function showToast(message) {
    let toast = document.getElementById('apronze-wishlist-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'apronze-wishlist-toast';
      toast.className = 'apronze-wishlist-toast';
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.classList.add('show');
    clearTimeout(toast._timer);
    toast._timer = setTimeout(function () { toast.classList.remove('show'); }, 2200);
  }

  function syncHeartStates() {
    const wishlist = getWishlist();
    const ids = wishlist.map(function (item) { return String(item.id); });

    document.querySelectorAll('.apronze-product-card__wishlist').forEach(function (btn) {
      const pid = String(btn.getAttribute('data-wishlist-id'));
      const icon = btn.querySelector('.apronze-wishlist-icon');

      if (ids.includes(pid)) {
        btn.classList.add('is-wishlisted');
        if (icon) icon.textContent = '♥';
      } else {
        btn.classList.remove('is-wishlisted');
        if (icon) icon.textContent = '♡';
      }
    });
  }

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.apronze-product-card__wishlist');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    const productId = String(btn.getAttribute('data-wishlist-id'));
    const productHandle = btn.getAttribute('data-wishlist-handle');
    const icon = btn.querySelector('.apronze-wishlist-icon');

    let wishlist = getWishlist();
    const existingIndex = wishlist.findIndex(function (item) { return String(item.id) === productId; });

    if (existingIndex > -1) {
      wishlist.splice(existingIndex, 1);
      btn.classList.remove('is-wishlisted');
      if (icon) icon.textContent = '♡';
      showToast('Removed from wishlist');
    } else {
      wishlist.push({ id: productId, handle: productHandle });
      btn.classList.add('is-wishlisted');
      if (icon) icon.textContent = '♥';
      showToast('Added to wishlist ❤️');
    }
    saveWishlist(wishlist);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncHeartStates);
  } else {
    syncHeartStates();
  }

  window.addEventListener('apronze:recommendations-loaded', syncHeartStates);
})();


  } catch(e) { console.error(e); }
})();
})();
